<h2 class="modal-title m-b-4">Overhead categories</h2>

<div class="alert-legend m-b-2">
    <span class="alert-legend__item"><span class="alert-icon color--green">✓</span> OK (within annual and monthly budget pace)</span>
    <span class="alert-legend__item"><span class="alert-icon color--orange">!</span> Over monthly budget pace</span>
    <span class="alert-legend__item"><span class="alert-icon color--red">!</span> Over annual budget</span>
</div>

<div class="m-b-2">
    <label class="m-r-2">
        <input type="checkbox" [(ngModel)]="showHidden" (change)="onShowHiddenChange()" />
        Show hidden budgets
    </label>
</div>

<table
    #sort="matSort"
    [dataSource]="datasource"
    class="m-t-4"
    mat-table
    matSort
    matSortActive="alert"
    matSortDirection="desc">

    <ng-container matColumnDef="overheadCategory">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            Overhead category
        </th>
        <td *matCellDef="let financialData" mat-cell>
            <app-pill-overhead-category [onFinancialPage]="true" [overheadCategoryId]="financialData.objectId"></app-pill-overhead-category>
        </td>
    </ng-container>

    <ng-container matColumnDef="total">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Total costs for {{ selectedYear }}</th>
        <td *matCellDef="let financialData" mat-cell>{{financialData.total | currency: 'EUR'}}</td>
    </ng-container>

    <ng-container matColumnDef="average">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            Average costs for {{ selectedYear }}
        </th>
        <td *matCellDef="let financialData" mat-cell>
            {{financialData.average | currency: 'EUR'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="budget">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            Budget for {{ selectedYear }}
        </th>
        <td *matCellDef="let financialData" mat-cell>
            {{ (financialData.budget || 0) | currency: 'EUR' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="alert">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Alert</th>
        <td *matCellDef="let financialData" mat-cell>
            <ng-container *ngIf="getAlert(financialData) as alert">
                <div class="alert-cell-row">
                    <span
                        class="alert-cell"
                        [ngClass]="{
                            'color--green': alert.level === 'ok',
                            'color--red': alert.level === 'over-budget',
                            'color--orange': alert.level === 'over-monthly-pace'
                        }">
                        {{ alert.label }}
                    </span>
                    <span *ngIf="alert.details" class="m-l-1">{{ alert.details }}</span>
                    <ng-container *ngIf="getOverageDetails(financialData) as overage">
                        <span
                            class="overage-badge"
                            [class.overage-badge--red]="alert.level === 'over-budget'"
                            [class.overage-badge--orange]="alert.level === 'over-monthly-pace'"
                            [ngbTooltip]="getOverageTooltip(overage.overageEur)">
                            +{{ overage.overagePct | number:'1.0-0' }}%
                            <span class="overage-badge__eur">({{ overage.overageEur | currency: 'EUR' }})</span>
                        </span>
                    </ng-container>
                </div>
            </ng-container>
        </td>
    </ng-container>

    <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="td-small"></th>
        <td mat-cell *matCellDef="let financialData" class="td-small" (click)="$event.stopPropagation()">
            <div class="dropdown" ngbDropdown>
                <button class="button button--icon button--small dropdown-toggle" ngbDropdownToggle type="button"></button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                    <a class="dropdown-item" (click)="openEditBudgetModal(financialData)">Edit budget</a>
                    <a class="dropdown-item" (click)="openViewDetailsModal(financialData)">View details</a>
                    <a class="dropdown-item" (click)="toggleCategoryHidden(financialData)">
                        {{ isCategoryHidden(financialData) ? 'Unhide budget' : 'Hide budget' }}
                    </a>
                </div>
            </div>
        </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr (click)="openOverheadCategoryModal(row)" *matRowDef="let row; columns: displayedColumns" class="pointer"
        mat-row></tr>

    <tr *matNoDataRow>
        <td
            [attr.colspan]="displayedColumns.length"
            class="mat-cell">
            <ng-container *ngIf="loadingData; else loading">
                There are no overhead categories with financial data found for this year...
            </ng-container>
        </td>
    </tr>
</table>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
